import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import {
  CustomResultOfPaginatedListOfGetSmartSmsNumberClassWithPaginationDto,
  GetEnumValuesDto,
  GetSmartSmsNumberClassWithPaginationDto,
} from 'src/app/core/api/models';
import { SmartSmsNumberClassesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppDomService } from 'src/app/core/services/dom.service';
import { MenuBtnComponent } from 'src/app/shared/global/menu-btn/menu-btn.component';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { SmartSmsNumberClassesEditFormComponent } from './smart-sms-number-classes-edit-form/smart-sms-number-classes-edit-form.component';
import { SmartSmsNumberClassesFormComponent } from './smart-sms-number-classes-form/smart-sms-number-classes-form.component';

@Component({
  selector: 'app-smart-sms-number-classes',
  templateUrl: './smart-sms-number-classes.component.html',
  imports: [
    BaseIndexModule,
    MenuBtnComponent,
    SmartSmsNumberClassesFormComponent,
  ],
})
export class SmartSmsNumberClassesComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties
  pageName = PageNames.smartSmsNumberClasses;
  modelWithPagination$: Observable<CustomResultOfPaginatedListOfGetSmartSmsNumberClassWithPaginationDto>;
  items$: Observable<Array<GetSmartSmsNumberClassWithPaginationDto>>;
  SmsAggregatorEnumValues: GetEnumValuesDto[] = []; 

  /* binding service CRUD endpoints */
  protected currentService = inject(SmartSmsNumberClassesService);
  paginationApiMethodName: string =
    this.currentService
      .smartSmsNumberClassesGetSmartSmsNumberClassWithPagination.name;
  /* binding service CRUD endpoints */

  //#endregion

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showRefreshBtn = false;
      this.pageConfig.showAuditBtn = false;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }

  override onCreate(type?: any, isFormModal?: boolean) {
    try {
      this.setParentQueryString();

      this.location.go(window.location.pathname + '?key-formType=create');
      this.pageConfig.isVisibleForm = true;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }

  onUpdate(id?, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    this.onShowEditModal(id);
  }

  onShowEditModal(id) {
    try {
      this.unSubs();

      let data = {
        title: `${this.formPageConfig?.vocabs}editTitle`,
        isEdit: true,
        pageVocab: 'pages.otp.form.',
        model: {
          id: id,
        },
      };

      const modalResult = this.dialogService.openModal({
        component: SmartSmsNumberClassesEditFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }

  setDefaultTableSort() {
    try {
      //اگر از قبل مقدار وجود داشت دیگه push نکنه
      const isExistsSortObject = this.sortObject.some((item) =>
        item.columnName.includes('cityId')
      );
      if (!isExistsSortObject)
        this.sortObject.push({ columnName: 'cityId', sort: 1 });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.filimoSmart);
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmsAggregator')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsAggregatorEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: 'common.province',
        name: 'province',
        hasSearch: true,
      },
      { title: 'common.city', name: 'city', hasSearch: true },
      {
        title: `${this.tableVocabs}operatorClasses`,
        name: 'operatorClasses',
        hasSearch: false,
        noSorting: true,
        wrap: true,
      },
    ];
  }

  //#endregion
}
